import { Component, Inject, Input, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { CarouselComponent } from 'ngx-owl-carousel-o'

@Component({
  selector: 'app-image-popup',
  templateUrl: './image-popup.component.html',
  styleUrls: ['./image-popup.component.scss']
})
export class ImagePopupComponent {
  currentIndex: number;

  data:any;

  @ViewChild('carousel') carousel: CarouselComponent;

  public serverPath1 = environment.commonImageApi + 'gallery/';

  constructor(
    public dialogRef: MatDialogRef<ImagePopupComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    
    this.data = data
  }

  images:any;

  ngOnInit(): void {

    console.log(this.data);
    

    this.images = this.data.images;


  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  // nextImage(): void {
  //   this.currentIndex = (this.currentIndex + 1) % this.data.images.length;
  // }

  // prevImage(): void {
  //   this.currentIndex = (this.currentIndex - 1 + this.data.images.length) % this.data.images.length;
  // }

  nextImage(): void {
    this.carousel.next(); // Call next() on the carousel instance
  }

  prevImage(): void {
    this.carousel.prev(); // Call prev() on the carousel instance
  }


  LogoSlider = {
    nav: false,
    dots: false,
    items: 1,
    margin: 20,
    loop: true,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 3000,
    navText: ['<', '>'],

    responsive: {
      767: {
        items: 1
      },
      576: {
        items: 1
      },
      480: {
        items: 1
      },
      0: {
        items: 1
      }
    }
  }

}
